import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useToggle } from 'react-use';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { ContactResultItem } from 'components/ExpertSearch/components/ContactResultItem/ContactResultItem';
import { GenericModal } from 'components/GenericModal';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { TENANT_ID } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

export const ExpertSearchResult = ({ data, onReset }) => {
  const [openModal, toggleModal] = useToggle(false);
  const [indexOfContact, setIndexOfContact] = useState(0);

  const modal = {
    title: 'Ihre Nachricht',
    subtitle: 'Meine Installateurnummer',
    email: data.contacts[indexOfContact].email,
  };

  const resetSearch = () => {
    onReset();
  };

  const scrollTo = (ref) => {
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: 'smooth',
    });
  };

  const typeMapping = (type) => {
    const expertTypes = [
      {
        type: 'STROM',
        name: 'Strom',
      },
      {
        type: 'GAS',
        name: 'Gas',
      },
      // E.DIS specific type
      {
        type: 'EINSPEI30',
        name: 'Einspeiser bis 30kW',
      },
      // E.DIS specific type
      {
        type: 'EINSPEIG30',
        name: 'Einspeiser > 30kW Niederspannung',
      },
      {
        type: 'STROMHELP',
        name: 'Strom',
      },
      {
        type: 'GASHELP',
        name: 'Gas',
      },
      {
        type: 'PPJ',
        name: 'Installateur-Betreuung',
      },
      {
        type: 'EDIS',
        name: 'E.DIS Service',
      },
      {
        type: 'TAB',
        name: 'TAB-Ansprechpartner',
      },
      {
        type: 'CONTACT',
        name: 'Netzanschluss / Einspeiser',
      },
    ];

    const name = expertTypes
      .map((t) => (t.type === type ? t.name : undefined))
      .find((elem) => elem !== undefined);
    if (name !== undefined) {
      return name;
    }
    return type;
  };

  return (
    <>
      <SubTitle text="Ihr Expertenkontakt" notFramed />
      <div className="expert-search-results">
        {data.contacts.map((result, index) => (
          <ContactResultItem
            key={index}
            title={typeMapping(result.type)}
            marker={result.marker}
            salesOffice={getTenantId() === TENANT_ID.BAG && result.location.salesOffice}
            phoneNumberCall={result.phoneNumberCall}
            phoneNumberDisplay={result.phoneNumberDisplay}
            onSendMessageClick={() => {
              setIndexOfContact(index);
              toggleModal();
            }}
          />
        ))}
        <ActionButton onClick={resetSearch} title="Neue Suche" inverted />
        <GenericModal data={modal} openModal={openModal} closeModal={toggleModal} />
      </div>
    </>
  );
};

ExpertSearchResult.propTypes = {
  data: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
};
